export default function ChatbotIcon({ className = "", onClick = null }) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
      role="img"
      aria-label="Chatbot"
    >
      <path
        d="M412.05,233.16c0,20.07-13.36,37.03-31.67,42.46-12.3,54.04-57.43,95.73-113.22,102.91-.19,5.14-4.42,9.24-9.61,9.24h-39.93c-5.31,0-9.62-4.3-9.62-9.62v-15.04c0-5.31,4.31-9.62,9.62-9.62h39.93c4.38,0,8.07,2.92,9.24,6.92,45.52-6.64,82.53-39.89,94.67-83.41,2.76-9.89,4.24-20.3,4.24-31.06,0-19.6-4.9-38.07-13.54-54.26-19.47-36.53-57.96-61.44-102.16-61.44s-82.69,24.91-102.16,61.44c-8.64,16.19-13.54,34.66-13.54,54.26,0,7.91.8,22.35,2.38,31.29-1.46.15-2.94.22-4.44.22-4.39,0-8.62-.64-12.62-1.83-18.31-5.43-31.67-22.39-31.67-42.46,0-23.4,18.13-42.55,41.1-44.18,21.42-45.32,67.59-76.74,120.95-76.74s99.53,31.42,120.95,76.74c22.97,1.63,41.1,20.78,41.1,44.18Z"
        fill="currentColor"
      />
      <path
        d="M331.84,207.21c-14.51-30.62-45.7-51.8-81.84-51.8s-67.33,21.18-81.84,51.8c-5.57,11.74-8.68,24.87-8.68,38.72,0,6.96.79,13.74,2.28,20.25,1.85,8.13,4.81,15.85,8.69,22.98l-11.45,42.74c-1.12,4.17,2.7,7.98,6.87,6.87l43.87-11.76c12.12,6.04,25.79,9.43,40.26,9.43,43.03,0,79.05-30.02,88.24-70.26,1.49-6.51,2.28-13.29,2.28-20.25,0-13.85-3.11-26.98-8.68-38.72ZM208,262.91c-9.38,0-16.98-7.6-16.98-16.97s7.6-16.98,16.98-16.98,16.98,7.6,16.98,16.98-7.6,16.97-16.98,16.97ZM250,262.91c-9.38,0-16.98-7.6-16.98-16.97s7.6-16.98,16.98-16.98,16.98,7.6,16.98,16.98-7.6,16.97-16.98,16.97ZM292,262.91c-9.38,0-16.98-7.6-16.98-16.97s7.6-16.98,16.98-16.98,16.98,7.6,16.98,16.98-7.6,16.97-16.98,16.97Z"
        fill="currentColor"
      />
    </svg>
  );
}
